import { registerApolloAuthRecoveryHandlers } from '@/shared/api';
import { registerAuthStoreSelector, registerFreshchatUserUpdater } from '@/shared/lib';
import {
  handleLoginAsClinic,
  fetchMe,
  handleUpdateUser,
  useUserStore,
  handleCheckRoles,
} from '@/entities/user';

/**
 * Wires the shared layer's dependency slots to the concrete entity implementations at app start-up, so shared code never imports upwards. Installs the Apollo auth recovery handlers for clinic login, current-user fetch and role checking, points the auth store selector at the user store's me id, and registers the Freshchat user updater.
 *
 * @returns Nothing.
 */
export const registerSharedDependencies = () => {
  registerApolloAuthRecoveryHandlers({ handleLoginAsClinic, fetchMe, handleCheckRoles });
  registerAuthStoreSelector(() => useUserStore.getState().me?.id);
  registerFreshchatUserUpdater(handleUpdateUser);
};
